export default "__VITE_ASSET__CZR_RoK7__"